import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const OrdersPageLink = () => {

  return (
    <AsideMenuLink
      pathname={P.ORDERS_PAGE}
      subject={S.ORDERS_PAGE}
      icon={'Order_red.svg'}
      label={<FormattedMessage id="orders-page-link" defaultMessage="Orders"/>}
    />
  );
};

export default OrdersPageLink;
